import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 22a2 2 0 0 1-2-2', key: 'i7yj1i' }],
  ['path', { d: 'M14 2a2 2 0 0 1 2 2', key: '170a0m' }],
  ['path', { d: 'M16 22h-2', key: '18d249' }],
  ['path', { d: 'M2 10V8', key: '7yj4fe' }],
  ['path', { d: 'M2 4a2 2 0 0 1 2-2', key: 'ddgnws' }],
  ['path', { d: 'M20 8a2 2 0 0 1 2 2', key: '1770vt' }],
  ['path', { d: 'M22 14v2', key: 'iot8ja' }],
  ['path', { d: 'M22 20a2 2 0 0 1-2 2', key: 'qj8q6g' }],
  ['path', { d: 'M4 16a2 2 0 0 1-2-2', key: '1dnafg' }],
  [
    'path',
    { d: 'M8 10a2 2 0 0 1 2-2h5a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2H9a1 1 0 0 1-1-1z', key: 'ci6f0b' },
  ],
  ['path', { d: 'M8 2h2', key: '1gmkwm' }],
];

/**
 * @component @name SquaresIntersect
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJhMiAyIDAgMCAxLTItMiIgLz4KICA8cGF0aCBkPSJNMTQgMmEyIDIgMCAwIDEgMiAyIiAvPgogIDxwYXRoIGQ9Ik0xNiAyMmgtMiIgLz4KICA8cGF0aCBkPSJNMiAxMFY4IiAvPgogIDxwYXRoIGQ9Ik0yIDRhMiAyIDAgMCAxIDItMiIgLz4KICA8cGF0aCBkPSJNMjAgOGEyIDIgMCAwIDEgMiAyIiAvPgogIDxwYXRoIGQ9Ik0yMiAxNHYyIiAvPgogIDxwYXRoIGQ9Ik0yMiAyMGEyIDIgMCAwIDEtMiAyIiAvPgogIDxwYXRoIGQ9Ik00IDE2YTIgMiAwIDAgMS0yLTIiIC8+CiAgPHBhdGggZD0iTTggMTBhMiAyIDAgMCAxIDItMmg1YTEgMSAwIDAgMSAxIDF2NWEyIDIgMCAwIDEtMiAySDlhMSAxIDAgMCAxLTEtMXoiIC8+CiAgPHBhdGggZD0iTTggMmgyIiAvPgo8L3N2Zz4=) - https://lucide.dev/icons/squares-intersect
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquaresIntersect = createLucideIcon('squares-intersect', __iconNode);

export default SquaresIntersect;
